import { useEffect, useState } from "react";
import API from "../../services/API";
import { TokenService } from "../../services/LocalStorage";
import { ResolvedForm } from "../../interfaces/ResolvedForm";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Modal } from "../../components/widgets/Popup";
import TranslatableText from "../../components/Multilanguage/TranslatableText";
import Tooltip from "../../components/widgets/Tooltip";
type TabFormProps = {
  ReqId: string;
  estado: any;
  solicitud: any;
  children?: React.ReactNode;
};
function TabForm({ estado,solicitud, ReqId, children }: TabFormProps) {
  const [resolvedForm, setResolvedForm] = useState<ResolvedForm>({
    FormId: 0,
    RegisterId: 0,
    ResolvedQuestions: [],
  });

  const { t } = useTranslation()

  const [showTextComplete, setShowTextComplete] = useState(false);
  const [files, setFiles] = useState<any>([])
  const [documentLoad, setdocumentLoad] = useState<any>(null)
  const [visible, setVisible] = useState<boolean>(false);
  const [archivoSeleccionado, setArchivoSeleccionado] = useState<any>(null);
  const [idActual, setIdActual] = useState<any>(null);

  const toggleDialog = (archivo?: any) => {
    if (archivo) {
      setArchivoSeleccionado(archivo); // Guardamos el archivo seleccionado
    }
      setVisible(!visible);
  };
  const numero = (ruta : string)=>{
    const partes = ruta.split("/"); 
    const id = partes[4]; // Índice donde está el número
    setIdActual(id)
  }
  const truncateMiddle = (text: string, startLength = 10, endLength = 5) => {
    if (text.length <= startLength + endLength) return text;
    return text.slice(0, startLength) + "..." + text.slice(-endLength);
  };
  const eliminarArchivo = (nombreArchivo: string, id: string) => {
   
  
    setFiles((prevFiles: Record<string, { nombre: string; ruta: string }[]>) => {
      // Verifica si la clave `id` existe en `prevFiles`
      if (!prevFiles[id]) return prevFiles;
  
      // Filtra los archivos que NO sean el eliminado
      const updatedFiles = prevFiles[id].filter(file => file.nombre !== nombreArchivo);
  
      // Si no hay archivos restantes, elimina la clave `id`
      const newFilesState = { ...prevFiles };
      if (updatedFiles.length > 0) {
        newFilesState[id] = updatedFiles;
      } else {
        delete newFilesState[id];
      }
  
      return newFilesState;
    });

    const URL = `${process.env.REACT_APP_API_URL}/file/DeleteFile/1/${ReqId}/${nombreArchivo}`;
    const helppeopleHeaders = { 
      "x-helppeople-token": TokenService.get(),
      "x-helppeople-useraction": "2",
      "x-helppeople-registerid": id
    };
  
    fetch(URL, { method: "DELETE", headers: helppeopleHeaders })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error al eliminar el archivo: ${response.statusText}`);
        }
        toast.success(`${t("requestDetail.tabForm.deleteAttachment")}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
       
        toast.error(error.message || "Error al eliminar el archivo", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  
    toggleDialog();
  };
  


  const descargaAdjunto =  (ruta: string) => {
    
    const encodePath = encodeURIComponent(ruta);
    const rutaNormalizada = ruta.replace(/\\/g, "/");
    const nombreArchivo = rutaNormalizada.split("/").pop() || "archivo_descargado";
   
    setdocumentLoad(ruta);
    
    API(true)
      .get(`Flow/file/GetFile/adj?pathFull=${encodePath}`,{ responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", nombreArchivo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setdocumentLoad(null);
      })
      .catch((e) => {
        console.error(e.message);
        setdocumentLoad(null);
      });
  }


  useEffect(() => {

    
    API()
      .post(`Formulario/GetResolvedForm`, {
        Token: TokenService.get(),
        RegisterId: ReqId,
        RegisterType: 1,
      })
      .then(async(response) => {
        if (response.data.Status === "Ok") {
          setResolvedForm(response.data.Values);

          const questionIds =
          response.data.Values?.ResolvedQuestions?.filter(
            (item: any) => item.ComponentId === 2
          ).map((item: any) => item.QuestionId) || [];

        // 🔹 Ejecutar todas las llamadas a FilesAttach en paralelo y esperar su finalización
        await Promise.all(questionIds.map((ids: string) => FilesAttach(ids)));
        }
      })
      .catch((e) => {
        console.error(e.message);
      });


      
  }, [ReqId]);

  const FilesAttach = async (ids: string) => {
    try {
      const response = await API(true).get(
        `Flow/s3/showFileAll?path=AdjuntoFormularioDinamico/${ReqId}/${ids}`
      );
  
      const filesArray = response.data || [];
  
      let filesForm: Record<string, { nombre: string; ruta: string }[]> = {};
  
      filesArray.forEach((ruta: string) => {
        const rutaNormalizada = ruta.replace(/\\/g, "/");
        const fileName = rutaNormalizada.split("/").pop() || "archivo_descargado";
  
        if (!filesForm[ids]) {
          filesForm[ids] = [];
        }
  
        filesForm[ids].push({
          nombre: fileName,
          ruta: rutaNormalizada,
        });
      });
  
      // 🔹 Actualizar el estado una sola vez preservando valores previos
      setFiles((prevState : any) => ({
        ...prevState,
        ...filesForm,
      }));
    } catch (error) {
      console.error("Error al obtener archivos:");
    }
  };
  const toggleTextComplete = () => {

    setShowTextComplete(!showTextComplete);
  };

  return (
    <div className="w-full grid grid-cols-3 gap-6">
      {resolvedForm?.ResolvedQuestions.length > 0 ? (
        resolvedForm?.ResolvedQuestions.map((question) => {
          
         
          return (
            <>
              <div
                key={question.QuestionId}
                className="col-span-3 lg:col-span-1  md:col-span-1"
              >
                <p className="text-sm sm:text-md md:text-lg text-blue-600">
                  <TranslatableText text={question.QuestionDescription} />{" "}
                </p>
                {question.AnswerDescription !== ""   ? (
                  <p className="text-sm sm:text-md md:text-lg w-full break-words">
                    <TranslatableText text={question.AnswerDescription} />
                  </p>
                ) : null}
               
                
               {question.ComponentId === 2 && 
 Object.keys(files).length > 0 && 
 files[question.QuestionId] && 
 Array.isArray(files[question.QuestionId]) && 
 files[question.QuestionId].map((it: any)=>{
                    
                           return( <>  
                           
                           <Tooltip title={`${it?.nombre}`}>  
                            <div style={{maxWidth:'250px'}}  className="d-flex justify-content-between align-items-center   p-1">
                               
    
                             
                              <button 
                                    onClick={() => descargaAdjunto(it?.ruta)}
                                     style={{border:'none'}}
                                      disabled={documentLoad === it?.nombre}
                                   > 
                                   <div style={{ display: "flex", alignItems: "center" }}>
                                     {/* Ícono del archivo */}
                                      <div className="me-2">
                                       <svg
                                         width="40"
                                         height="40"
                                         viewBox="0 0 24 24"
                                         fill="none"
                                         stroke="#d9d9d9"
                                         strokeWidth="1"
                                         strokeLinecap="round"
                                         strokeLinejoin="round"
                                       >
                                         <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                                         <polyline points="14 2 14 8 20 8" />
                                       </svg>
                                     </div>
                                                                         
                                     <div className="d-flex align-items-center justify-content-between w-100">
                                     <div className="text-secondary" style={{ fontSize: "14px" }}>
                                     {it?.nombre.length >= 19 ?truncateMiddle(it?.nombre):it?.nombre}
                                   
                                       </div> 
    
                                       
                                       {
                                        documentLoad === it?.ruta ?  "...." :(<></>)
                                       }
                                       
                                     </div>
                                   </div>
                                   </button>
                              {
                                solicitud =="Cerrada" ? '':
                                estado ==="Anulada" ?'':
                                estado ==="Solucionado" ?'':(<button onClick={() => {
                                 numero(it.ruta)
                                 toggleDialog(it)
                               } } style={{ fontSize:'25px', float: 'inline-end',color:'red'}} >
                                    x
                              </button>)
                              }
                                   

                               </div>
                               </Tooltip> 
                                         </>
                             )
                         }
                          
                         ) 
                       
                     }
                      {visible && (
                        <Modal setModalActive={toggleDialog} active={visible} height="auto">
                        <div className="p-4 flex flex-col items-center justify-center text-center space-y-4 overflow-y-auto max-h-full break-words">
                          <br />
                          <Tooltip title={`${archivoSeleccionado?.nombre}`}>
                            <p className="text-lg font-semibold">
                            ¿<TranslatableText text={"Desea eliminar "} />
                            {truncateMiddle(archivoSeleccionado?.nombre)}?
                          </p>
                          </Tooltip>
                          
                      
                          <div className="flex justify-center w-full gap-4 flex-wrap">
                            <button 
                              type="button" 
                              onClick={toggleDialog} 
                              className="px-4 py-1 rounded-lg bg-red-500 text-white font-semibold hover:bg-red-600 transition-all duration-200 shadow-md"
                            >
                              {t("requestDetail.tabForm.no")}
                            </button>
                            <button 
                              type="button" 
                              onClick={() => eliminarArchivo(archivoSeleccionado?.nombre, `${idActual}`)} 
                              className="px-4 py-1 rounded-lg bg-green-500 text-white font-semibold hover:bg-green-600 transition-all duration-200 shadow-md"
                            >
                              {t("requestDetail.tabForm.si")}
                            </button>
                          </div>
                        </div>
                      </Modal>
                      
                          
                                      )}
              
                
                {question.Answer !== "" && question.ComponentId !==2 ? (
                  <p className="text-sm sm:text-md md:text-lg w-full break-words">
                    {/* {question.Answer} */}
                    {showTextComplete || question.Answer.length <= 300 ? (
                      <><TranslatableText text={question.Answer} /></>
                    ) : (
                      <><TranslatableText text={question.Answer.substring(0, 300)} /></>
                    )}
                  </p>
                ) : files.length ===0 ?  question.ComponentId ===2?  <TranslatableText text={'No hay adjunto'}/> :'':''}
                {question.Answer.length > 300 && (
                  <button
                    className="text-sm sm:text-md md:text-lg text-blue-600"
                    onClick={toggleTextComplete}
                  >
                    {showTextComplete ? t("requestDetail.tabForm.viewLess") : t("requestDetail.tabForm.viewMore") }
                  </button>
                )}

                {question.AnsweredOptions.map((option) => {
                  return (
                    <p className="text-sm sm:text-md md:text-lg ">
                      <TranslatableText text={option.OptionDescription}/>
                    </p>
                  );
                })}

                {/* {question.ComponentId === 5 ? <></> : <></>}
                        {question.ComponentId === 6 ? <></> : <></>}
                        {question.ComponentId === 7 ? <>
                            <p className="text-sm sm:text-md md:text-lg">{question.Answer} </p>
                        </> : <></>} */}
              </div>
            </>
          );
        })
      ) : (
        <div className="col-span-3">
          <p className="text-sm sm:text-md md:text-lg text-center">
            {t("requestDetail.tabForm.empty")}
          </p>
        </div>
      )}
    </div>
  );
}
export default TabForm;
